import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { BehaviorSubject, Subject, Unsubscribable } from 'rxjs';
import { IValueChangedEvent } from '../../../wizard.content';
import { cloneDeep, filter, get, uniq } from 'lodash';
import {
  EntityCacheProvider,
  IAlertListRow,
  ISeverityEnum,
  ITableObject,
  TransformationService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';
import { UserSiteSelectioniwizardService } from './user.site.selection.service';
import { ViewTableComponent } from '@nrwl/view-table';

@Component({
  selector: 'wizard-email-application',
  templateUrl: './user.sites.selection.component.html',
  styleUrls: ['./user.site.selection.scss'],
  providers: [UserSiteSelectioniwizardService]
})
export class UserSitesSelectionComponent implements OnInit, OnDestroy {
  @ViewChild(ViewTableComponent, { static: true }) child: ViewTableComponent;
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  wizardService: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  dataSource: Subject<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  pageSize = 10;
  pageSizeOptions = [10];
  showPaginator: BehaviorSubject<boolean>;
  selectedRowIndex: BehaviorSubject<number>;
  searchText: BehaviorSubject<string>;
  selectedItem: BehaviorSubject<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  dataSourceTableData: any = []; //eslint-disable-line @typescript-eslint/no-explicit-any
  userSiteList: ITableObject;
  filterSiteList: ITableObject;
  tableOptions = {
    hideActionsColumn: false
  };
  searchField = '';
  onTableRowClick: Function; // eslint-disable-line
  siteList: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  exchangeUnsubscribe: Unsubscribable;

  constructor(
    private readonly entityCache: EntityCacheProvider,
    private readonly transformService: TransformationService,
    private readonly exchange: ValuesExchangeProvider
  ) {
    this.onTableRowClick = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.dataSource = new BehaviorSubject<any>(null);
    this.showPaginator = new BehaviorSubject<boolean>(true);
    this.selectedRowIndex = new BehaviorSubject<number>(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.selectedItem = new BehaviorSubject<any>(null);
  }

  ngOnDestroy() {
    this.dataSource.unsubscribe();
    this.showPaginator.unsubscribe();
    this.selectedRowIndex.unsubscribe();
    if (this.exchangeUnsubscribe) {
      this.exchangeUnsubscribe.unsubscribe();
    }
  }

  ngOnInit() {
    this.siteList = this.entityCache.findEntityCache('site').getValues();
    this.assignData(this.siteList);
    this.child.selection.changed.subscribe(() => {
      this.selectedRow();
    });
    this.exchangeUnsubscribe = this.exchange.registerInterest(
      'sites-filter',
      this.addSelectedSiteList.bind(this)
    );
    this.selectedRow();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  assignData(data: any): void {
    this.userSiteList = this.transformService.transformData('user-site-management', data);
    this.dataSource.next(this.userSiteList);
    this.filterSiteList = cloneDeep(this.userSiteList);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  onSearchTextChange(searchText: any): any {
    searchText = searchText.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.userSiteList.data = filter(this.filterSiteList.data, (item: any) => {
      if (item.name.toLowerCase().indexOf(searchText) >= 0) {
        return item;
      }
    });
    this.dataSource.next(this.userSiteList);
  }

  selectedRow(): void {
    const selectedRows = this.getSelectedItems();
    this.onDataValueChange.emit({
      componentId: 'user_site_selection',
      key: 'selectedSites',
      newValue: selectedRows,
      isValid: selectedRows.length > 0
    });
  }

  getSelectedItems(): Array<string> {
    return get(this, 'child.selection.selected', []).map(item => {
      const siteDetails = this.siteList.find(value => value.sitesData.id === item);
      return {
        siteId: item,
        name: siteDetails.escapedName,
        minimumSeverity: ISeverityEnum.WARNING
      };
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  addSelectedSiteList(data: IAlertListRow[] = []): any {
    if (!data.length) {
      return;
    }
    const uniqueSiteIds = uniq(data.map(item => item.siteId));
    this.userSiteList.data = this.userSiteList.data.filter(
      site => !uniqueSiteIds.includes(site.id)
    );
    this.dataSource.next(this.userSiteList);
    this.filterSiteList = cloneDeep(this.userSiteList);
  }
}
